import { useEffect, useState } from "react";
import { getWaiverService, WaiverListItem } from "./waiverApi";

export default function useWaiverMenuItems({enabled}: {enabled: boolean}) {
  const [waivers, setWaivers] = useState<WaiverListItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (enabled) {
      loadWaivers();
    }
  }, [enabled]);

  async function loadWaivers() {
    try {
      setLoading(true);
      const service = getWaiverService();
      const result = await service.paginateItems(
        "page=1&limit=3&sortBy=id&sortDirection=asc"
      );

      if (result?.data) {
        setWaivers(result.data.slice(0, 3)); // Ensure we only get 3
      }
    } catch (error) {
      console.error("Failed to load waivers for menu:", error);
      setWaivers([]);
    } finally {
      setLoading(false);
    }
  }

  return {
    waivers,
    loading,
  };
}
